import React from "react";
import loaderImg from "assets/lab/images/loader.svg";
import { Img } from "react-image";

export default () => (
  <div id="global-loader">
    <Img src={loaderImg} className="loader-img" alt="" />
  </div>
);
